module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/index/icon_app-561680a1d6ac9725df6196cd055a5681.png";